import { LocalDate } from 'js-joda';

import AppConstants from 'constants/AppConstants';

interface State {
  selectedDate: LocalDate;
}

const initialState: State = {
  selectedDate: LocalDate.now(),
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { payload, type } = action;
  switch (type) {
    case AppConstants.DELIVERY_DATE_CHANGE: {
      return {
        ...state,
        selectedDate: payload,
      };
    }
    default: {
      return state;
    }
  }
}
